<template>
  <survey-view
    v-if="userInfo.socialId"
    :survey-i-d="EvaluationsCode"
    :lang="qaimConfig ? qaimConfig.qaimSettings.language : 'AR' "
    :first-name="userInfo.firstName"
    :last-name="userInfo.familyName"
    :nationality-id="userInfo.socialId"
    :gender="sexName"
    :ref-num="refNumber"
    :config="qaimConfig.qaimConfig"
    :header-text="surveyTitle"
    @OnSurveyClosed="clickHandler"
  >
  </survey-view>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import surveyView from '@t2/QaimPackage';
import '@t2/QaimPackage/dist/surveyview.css';
// import { qaimConfig } from '@/helpers/enum';

const { mapState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
export default {
  components: { surveyView },
  props: ['requestEvaluationsCode', 'refNum', 'isLawsuitRequest', 'headerText'],
  data() {
    return {
      EvaluationsCode: this.requestEvaluationsCode,
      refNumber: this.refNum,
      lawsuitRequest: this.isLawsuitRequest,
      userInfo: {},
    };
  },
  computed: {
    ...mapState({ qaimConfig: state => state.qaimConfig }),
    sexName() {
      return this.userInfo.gender === 1 ? 'M' : 'F';
    },
    surveyTitle() {
      return this.headerText ?? '';
    },
  },
  mounted() {
    this.getUserInfo().then((user) => {
      this.userInfo = user;
    });
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    clickHandler(e) {
      if (!this.lawsuitRequest) {
        this.$router.push({ path: '/' });
      } else {
        this.$emit('updateShowEvaluationModal');
      }
    },
  },
};
</script>
